"use client";

import styled from "styled-components";

export const DescriptionText = styled.div`
  font-family: "Inter Medium";
  font-size: 14px;
  color: var(--textLight);
  margin-bottom: 5px;
`;
